import { SET_NOTIFICATIONS } from "./types";
export const setNotificationData = (notifications, newCount) => {
  // console.log("newNoti", newCount);
  return (dispatch) => {
    dispatch({
      type: SET_NOTIFICATIONS,
      payload: {
        notifications: notifications,
        newNotifications: newCount,
      },
    });
  };
};
